<template>
  <v-layout row wrap>
    <v-flex xs12 v-if="is_list_available">
      <ScreenerList :list="todayList" :is_today="true"></ScreenerList>
    </v-flex>
  </v-layout>
</template>

<script>
import {mapState} from 'vuex';
import ScreenerList from '@/components/screener/List';
export default {
  name: 'ScreenerToday',
  metaInfo() {
    return {
      title: 'Screeners',
    };
  },
  components: {
    ScreenerList,
  },
  data: () => ({
    is_list_available: false,
  }),

  computed: {
    ...mapState({
      todayList: (state) => state.screening.todayList,
    }),
  },
  watch: {
    todayList() {
      this.is_list_available = true;
    },
  },
  created() {
    this.getApiData();
  },
  methods: {
    async getApiData() {
      try {
        this.$store.dispatch('screening/todayList');
      } catch (error) {
        this.$store.dispatch('app/showMessage', {
          message: error.message,
          color: 'error',
        });
      }
    },
  },
};
</script>
